import { NgModule } from '@angular/core';
import {  RouterModule, Routes } from '@angular/router';
import { SecureInnerPagesGuard } from './guards/secure-inner-pages.guard';
import { BeerDetailPage } from './pages/inventory/beer/beer-detail/beer-detail.page';
import { KegDetailPage } from './pages/keg/keg-detail/keg-detail.page';
import { FermenterDetailPage } from './pages/fermenter/fermenter-detail/fermenter-detail.page';
import { TapDetailPage } from './pages/tap-tower/tap/tap-detail/tap-detail.page';
import { TowerDetailPage } from './pages/tap-tower/towers/detail/detail.page';
import { LocationDetailPage } from './pages/inventory/location/location-detail/location-detail.page';
import { towerDetailResolverFn } from './resolvers/tower-detail-resolver';
import { locationDetailResolverFn } from './resolvers/location-detail-resolver';
import { tapDetailResolverFn } from './resolvers/tap-detail-resolver';
import { beverageDetailResolverFn } from './resolvers/beverage-detail-resolver';
import { kegDetailResolverFn } from './resolvers/keg-detail-resolver';
import { fermenterDetailResolverFn } from './resolvers/fermenter-detail-resolver';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/home/taps',
    pathMatch: 'full'
  },
  {
    path: 'settings',
    canActivate: [SecureInnerPagesGuard],
    loadChildren: () => import('./pages/settings/settings.routes').then(m => m.SETTINGS_ROUTES)
  },
  {
    path: 'login',
    // canActivate: [AuthGuard],
    loadComponent: () => import('./pages/authentication/login/login.page').then(m => m.LoginPage)
  },
  {
    path: 'forgot-password',
    // canActivate: [AuthGuard],
    loadComponent: () => import('./pages/authentication/forgot-password/forgot-password.page').then(m => m.ForgotPasswordPage)
  },
  {
    path: 'register',
    // canActivate: [AuthGuard],
    loadComponent: () => import('./pages/authentication/register/register.page').then(m => m.RegisterPage)
  },
  {
    path: 'home',
    loadChildren: () => import('./pages/home/home.routes').then(m => m.ROUTES),
    canActivate: [SecureInnerPagesGuard]
  },
  {
    path: 'inventory',
    loadChildren: () => import('./pages/inventory/inventory.routes').then(m => m.INVENTORY_ROUTES)
  },
  {
    resolve: { beverage: beverageDetailResolverFn },
    path: 'inventory/beer/details/:id',
    component: BeerDetailPage
  },
  {
    resolve: {
      keg: kegDetailResolverFn
    },
    path: 'inventory/kegs/details/:id',
    component: KegDetailPage
  },
  {
    resolve: {
      fermenter: fermenterDetailResolverFn
    },
    path: 'inventory/fermenter/details/:id',
    component: FermenterDetailPage
  },
  {
    resolve: {
      tap: tapDetailResolverFn
    },
    path: 'inventory/taps/details/:id',
    component: TapDetailPage
  },
  {
    resolve: {
      tower: towerDetailResolverFn
    },
    path: 'inventory/towers/details/:id',
    component: TowerDetailPage
  },
  {
    resolve: {
      location: locationDetailResolverFn
    },
    path: 'inventory/location/details/:id',
    component: LocationDetailPage
  },
  {
    path: 'checkout',
    canActivate: [SecureInnerPagesGuard],
    loadComponent: () => import('./pages/home/checkout/checkout.page').then(m => m.CheckoutPage)
  },
  // {
  //   path: 'stripe',
  //   canActivate: [SecureInnerPagesGuard],
  //   loadChildren: () => import('./pages/stripe/stripe.module').then( m => m.StripePageModule)
  // },
  {
    path: 'verify-email',
    loadComponent: () => import('./pages/authentication/verify-email/verify-email.page').then(m => m.VerifyEmailPage)
  },
  // {
  //   path: 'stripe',
  //   canActivate: [SecureInnerPagesGuard],
  //   loadChildren: () => import('./pages/stripe/stripe.module').then(m => m.StripePageModule)
  // },
  {
    path: 'subscription',
    loadComponent: () => import('./pages/subscriptions/subscription/subscription.page').then(m => m.SubscriptionPage)
  },
  {
    path: 'subscribe',
    redirectTo: 'subscription',
    pathMatch: 'full'
  },
  {
    path: 'admin',
    loadChildren: () => import('./pages/admin/admin.routes').then(m => m.ROUTES)
  },
  {
    path: 'tv',
    loadChildren: () => import('./pages/tv/advanced/advanced.routes').then(m => m.ROUTES)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notification/notification.routes').then(m => m.ROUTES)
  },
  {
    path: 'stripe-subscribe',
    loadComponent: () => import('./pages/subscriptions/stripe-subscribe/stripe-subscribe.page').then(m => m.StripeSubscribePage)
  },
  {
    path: 'tap-tower',
    loadChildren: () => import('./pages/tap-tower/tap-tower.routes').then(m => m.TAP_TOWER_ROUTES)
  },
  {
    path: '**',
    redirectTo: '/home/taps',
    pathMatch: 'full',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes)
  ],
  exports: [RouterModule]
})

export class AppRoutingModule { }
